export type ProvisioningForm = {
  switchStatus: boolean;
  routerStatus: boolean;
  accessPointStatus: boolean;
  gatewayCableStatus: boolean;
  gatewayProvisioningStatus: boolean;
}

export enum ProvisioningStep {
  network = "Provision Network",
  gateway = "Provision Gateway",
  devices = "Provision Devices",
  review = "Review Status",
}

export interface SmartstartParams {
  qr_code_string: string;
  device_name: string;
  property_area: string;
}
